import { get } from 'lodash';
import {
  ASSISTANCE,
  RIDESHARE,
  VEHICLE_RETIREMENT,
} from 'site-modules/shared/components/incentives/incentives-wizard/constants/qualifiers';
import {
  PARTICIPATE_IN_QUALITY_PROGRAMS_QUESTION_ID,
  RETIREMENT_QUESTION_ID,
  RIDESHARE_QUESTION_ID,
} from 'site-modules/shared/components/incentives/incentives-wizard/questions/questions';

const getFullDescriptionFromIncentive = (incentive, questionQualifier) =>
  incentive.rebateOverridesByEligibility
    .flatMap(({ eligibilityFactor }) => eligibilityFactor.qualifierDescriptions)
    .filter(qualifierDescription => !!qualifierDescription)
    .filter(({ qualifier }) => qualifier.toLowerCase() === questionQualifier)
    .map(({ description }) => description)
    .join(';');

export const getAllQualifierDescriptions = (incentives, questionId) => {
  if (!incentives) {
    return [];
  }

  const QUESTION_QUALIFIER_MAP = {
    [PARTICIPATE_IN_QUALITY_PROGRAMS_QUESTION_ID]: ASSISTANCE,
    [RETIREMENT_QUESTION_ID]: VEHICLE_RETIREMENT,
    [RIDESHARE_QUESTION_ID]: RIDESHARE,
  };

  const incentivesWithQualifierDescription = incentives.filter(incentive => {
    const rebateOverridesByEligibility = get(incentive, 'rebateOverridesByEligibility', []);
    if (!rebateOverridesByEligibility.length) return false;
    return rebateOverridesByEligibility.some(({ eligibilityFactor }) =>
      eligibilityFactor.qualifier?.toLowerCase().includes(QUESTION_QUALIFIER_MAP[questionId])
    );
  });

  if (!incentivesWithQualifierDescription.length) return [];

  return Array.from(
    new Set(
      incentivesWithQualifierDescription
        .reduce((qualifierDescription, incentive) => {
          const fullDescriptionFromIncentive = getFullDescriptionFromIncentive(
            incentive,
            QUESTION_QUALIFIER_MAP[questionId]
          );

          return qualifierDescription
            ? `${qualifierDescription};${fullDescriptionFromIncentive}`
            : fullDescriptionFromIncentive;
        }, '')
        .split(';')
        .filter(description => !!description)
    )
  );
};
